import { render, staticRenderFns } from "./ProductListForCollection.vue?vue&type=template&id=efa3ceb4&scoped=true"
import script from "./ProductListForCollection.vue?vue&type=script&lang=js"
export * from "./ProductListForCollection.vue?vue&type=script&lang=js"
import style0 from "./ProductListForCollection.vue?vue&type=style&index=0&id=efa3ceb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa3ceb4",
  null
  
)

export default component.exports